<template>
    <v-dialog v-model="dialog" width="100%"  style="margin: 100px !important;" persistent class="custom-dialog">
        <v-card>
            <v-card-title>
                <span class="text-h5">
                    Reprogramar
                </span>
            </v-card-title>

            <div style="padding: 20px">
                <v-data-table
                    :headers="headers"
                    :items="itemsParcelas"
                    class="elevation-1 mt-10"
                    disable-sort
                    hide-default-footer
                    show-expand
                    :expanded.sync="expanded"
                    item-value="id"
                >
                    <template v-slot:[`item.dataVencimento`]="{ item }">
                        <span>
                            {{ item.dataVencimento ? new Date(item.dataVencimento).toLocaleDateString('pt-BR') : 'Não Informado' }}
                        </span>
                    </template>

                    <template v-slot:[`item.parcelaPorcentagem`]="{ item }">
                        <span>
                            {{ `${item.parcelaPorcentagem}%` }}
                        </span>
                    </template>

                    <template v-slot:[`item.vrlParcela`]="{ item }">
                        <span>
                            {{ (item.vrlParcela / 100)?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
                        </span>
                    </template>

                      <template #footer>
                        <div class="px-4 py-2 text-right font-weight-bold">
                            Total geral: {{ itemsParcelas?.reduce((acc, item) => acc + (item.vrlParcela / 100), 0)?.toLocaleString('pt-BR', {
                                currency: 'BRL',
                                style: 'currency'
                            }) }}
                        </div>
                    </template>

                    <template v-slot:[`item.actions`]="{ item }">

                        <v-menu
                            bottom
                            left
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    dark
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                    color="black"
                                >
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            
                            <v-list>

                                <v-list-item style="cursor: pointer" @click="item._showReprogramar ? hiddenFieldDatePrev(item) : showFieldDatePrev(item)">
                                    <v-list-item-title>
                                    <span>{{ item._showReprogramar ? 'Cancelar' : 'Reprogramar' }}</span>
                                    </v-list-item-title>
                                </v-list-item>

                            </v-list>
                        </v-menu>
                    </template>
                    <template v-slot:[`item.dataPrevisao`]="{ item }">
                        <v-text-field
                            v-if="item._showReprogramar"
                            v-model="item.dataPrevisao"
                            dense
                            hide-details
                            type="date"
                            outline
                            @blur="hiddenFieldDatePrev(item)"
                        />
                        <span v-else>
                            {{ getDateFormat(item.dataPrevisao) }}
                        </span>
                    </template>
                    
                    <template v-slot:expanded-item="{ item }">
                        <v-btn :disabled="item.subItems ? item.subItems?.reduce((acc, subItem) => acc + parseCurrencyBR(subItem?.vrlParcela), 0) >= item.vrlParcela / 100 : true" color="primary" icon smal @click="addSubItem(item)" style="margin: 20px">
                            <v-icon> 
                                 mdi-plus 
                            </v-icon>
                        </v-btn>
                        <td :colspan="headers.length" style="padding: 20px;">
                            <v-simple-table dense>
                                <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Remover</th>
                                        <th>Parcela</th>
                                        <th>Tipo</th>
                                        <th>Data Vencimento</th>
                                        <th>Data Prev</th>
                                        <th>Percentual</th>
                                        <th>Valor da Parcela</th>
                                        <th>NF</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(sub, index) in item.subItems" :key="index">
                                        <td width="10">
                                            <v-btn color="red" icon smal @click="removeSubItem(item, index)">
                                                <v-icon>
                                                    mdi-delete
                                                </v-icon>
                                            </v-btn>
                                        </td>
                                        <td class="pa-5">{{ sub?.subParcelaSequencia || 0 }}</td>
                                        <td class="pa-5">
                                            <v-combobox 
                                                v-model="item.tipo"
                                                :items="['PV', 'NF']"
                                                dense
                                                hide-details
                                                outlined
                                                label="Tipo"
                                            />
                                        </td>
                                        <td class="pa-5">
                                            <v-text-field
                                                v-model="sub.dataVencimento"
                                                dense
                                                hide-details
                                                type="date"
                                                outline
                                                label="Data Vencimento"
                                                :readonly="true"
                                            />
                                        </td>
                                        <td class="pa-5">
                                            <v-text-field
                                                v-model="sub.dataPrevisao"
                                                dense
                                                hide-details
                                                type="date"
                                                outline
                                                label="Data Previsão"
                                            />
                                        </td>
                                        <td class="pa-5">
                                            <v-text-field
                                                :key="componentKey"
                                                v-model="sub.parcelaPorcentagem"
                                                type="text"
                                                dense
                                                hide-details
                                                outline
                                                suffix="%"
                                                label="Percentual"
                                                @blur="calcValue(sub.parcelaPorcentagem, item.vrlParcela / 100, sub)"
                                            />
                                        </td>
                                        <td class="pa-5">
                                            <v-text-field
                                                :key="componentKey"
                                                v-money="money"
                                                v-model="sub.vrlParcela"
                                                dense
                                                hide-details
                                                outline
                                                label="Valor da Parcela"
                                                @blur="calcPorcentagemParcela(sub.vrlParcela, item.vrlParcela / 100, sub)"
                                            />
                                        </td>
                                        <td class="pa-5"></td>
                                    </tr>
                                </tbody>
                                  <tfoot>
                                    <tr>
                                        <td colspan="2" class="text-right font-weight-bold">Total</td>
                                        <td class="font-weight-bold">
                                            {{ item.subItems?.reduce((acc, subItem) => acc + Number(parseCurrencyBR(subItem.vrlParcela)), 0)?.toLocaleString('pt-BR', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            }) }}
                                        </td>
                                    </tr>
                                </tfoot>
                                </template>
                            </v-simple-table>
                        </td>
                    </template>
            
                </v-data-table>
            </div>
            
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="$emit('cancel')">
                    Cancelar
                </v-btn>
                
                <v-btn color="blue darken-1" text @click="updateParcelas()">
                    Atualizar Parcelas
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import Vue, { readonly, watch } from 'vue';
import EntityService from "@/services/entityService.js";
import moment from 'moment';
import {VMoney} from 'v-money'

export default {
    name: 'ScheduleReprogramyView',
    props: ["open", 'jobId'],
    directives: { money: VMoney },
    data () {
        return {
            entityService: new EntityService('Parcelas'),
            entityServiceSubParcelas: new EntityService('SubParcelas'),
            dialog: false,
            expanded: [],
            componentKey: 0,
            totalParcelas: 0, 
            headers: [
                { text: 'Parcela', value: 'parcelaSequencia' },
                { text: 'Descrição', value: 'descricao' },
                { text: 'Tipo', value: 'tipo' },
                { text: 'Dias', values: 'parcelaDias' },
                { text: 'Data de Vencimento', value: 'dataVencimento' },
                { text: 'Data de Previsão', value: 'dataPrevisao' },
                { text: 'Percentual', value: 'parcelaPorcentagem' },
                { text: 'Valor Parcela', value: 'vrlParcela'},
                { text: 'NF', value: 'nfQtd' },
                { text: 'Actions', value: 'actions'}
            ],
            itemsParcelas: [],
            objSubParcelas: {
                subParcelaSequencia: '',
                code: '',
                tipo: 'PV',
                descricao: '',
                parcelaDias: 0,
                dataVencimento: '',
                dataPrevisao: '',
                parcelaPorcentagem: 0,
                vrlParcela: 0,
            },
            money: {
                locale: "pt-br",
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2,
                masked: false
            },
        }
    },
    computed: {
        sumSubParcela(){
            return true
        }
    },
    methods: {

        parseCurrencyBR(value) {
            if (typeof value === 'string') {
                return Number(
                String(value
                    .replaceAll(/[^\d,.-]+/g, '')
                    .replaceAll(/\./g, '')
                    .replaceAll(',', '.')
                ));
            }
            if (typeof value === 'number') return value;
            return 0;
        },

        verifySumParcelas(item){

            console.log('item >>> '. item)

            if(item?.subParcelas?.length > 0){
                let sum = 0
                item?.subParcelas.forEach((el) => {
                    sum += Number(el.vrlParcela)
                })

                return sum >= item?.vrlParcela
            }

            return true
        },

        async getCode(){
            let autoInc = await this.entityService.autoInc('SubParcelas', 'Code', '######')
            return autoInc.data
        },
        
        showFieldDatePrev(item){
            this.itemsParcelas = this.itemsParcelas.map(i =>
                i.parcelaSequencia === item.parcelaSequencia ? { ...i, _showReprogramar: true } : { ...i, _showReprogramar: false }
            );
        },

        hiddenFieldDatePrev(item){
            this.itemsParcelas = this.itemsParcelas.map(i =>
                i.parcelaSequencia === item.parcelaSequencia ? { ...i, _showReprogramar: false } : { ...i, _showReprogramar: false }
            );
        },

        async addSubItem(item) {
            let code = await this.getCode()
            this.itemsParcelas = this.itemsParcelas.map((i, index) =>
                i.parcelaSequencia === item.parcelaSequencia ? { ...i,
                    subItems: [
                        ...i?.subItems, { 
                            ...this.objSubParcelas, 
                            code, 
                            subParcelaSequencia: `${index + 1}.${i.subItems?.length + 1}`,
                            dataVencimento: item.dataVencimento ? moment(item.dataVencimento).format("YYYY-MM-DD") : null,
                        } 
                    ]
                } 
                : { ...i }
            );
        },
        
        removeSubItem(item, index) {
            item.subItems.splice(index, 1);
            this.$forceUpdate()
        },

        async getParcelasByJob(){
            let response = await this.entityService.getAll(1, 10000, this.jobId, 'job', null, null, null)
            this.itemsParcelas = response.data.data.data
            
            this.itemsParcelas = await Promise.all(
                this.itemsParcelas.map(async (item) => {

                    item.vrlParcela = item.vrlParcela * 100

                    if(item.parcelasItens?.length > 0){
                        const responseSubParcelas = await this.entityServiceSubParcelas.getAll(1, 10000, null, null, item.parcelasItens, null, null)
                        if(responseSubParcelas?.data?.data?.data.length > 0){
                            item.subItems = responseSubParcelas?.data?.data?.data

                            item.subItems = item.subItems?.map((subItem) => {
                                subItem.dataVencimento = item?.dataVencimento ? moment(item.dataVencimento).format("YYYY-MM-DD") : null;
                                subItem.dataPrevisao = subItem?.dataPrevisao ? moment(subItem.dataPrevisao).format('YYYY-MM-DD') : null;
                                return subItem
                            })
                        }
                    } else {
                        item.subItems = []
                    }

                    item._showReprogramar = false
                    return item
                })
            )
        },

        async updateParcelas(){
/*
            let verifyParcelas = []
            this.itemsParcelas.map((item) => {
                if(item.subItems?.filter((item) => item?.vrlParcela === 0).length > 0){
                    verifyParcelas.push(item.subItems?.filter((item) => item?.vrlParcela === 0))
                }
            })

            if(verifyParcelas.length > 0){
                this.$notfy.error('Existe parcelas sem valores.')
                return;
            }*/

            this.itemsParcelas = await Promise.all(
                this.itemsParcelas.map(async (item) => {
                    delete item.createAt
                    delete item.updatedAt
                    delete item.updateBy
                    delete item.createBy
                    delete item.updateBy
                    delete item.deleteAt
                    delete item.deleteBy
                    delete item._showReprogramar


                    if(item?.subItems?.length){
                        const insertSubParcelas = await Promise.all(
                            item.subItems.map(async (subItem) => {
                                delete subItem?.createAt
                                delete subItem?.updatedAt
                                delete subItem?.updateBy
                                delete subItem?.createBy
                                delete subItem?.updateBy
                                delete subItem?.deleteAt
                                delete subItem?.deleteBy

                                const vrlParcela = Number(
                                    String(subItem?.vrlParcela)
                                    .replace(/[^0-9,-]+/g, '')
                                    .replace('.', '')
                                    .replace(',', '.')
                                )

                                const responseInsert = await this.entityServiceSubParcelas.insertOrUpdate({ 
                                    ...subItem,
                                    subParcelaSequencia: Number(subItem?.subParcelaSequencia),
                                    parcelaDias: Number(subItem?.parcelaDias),
                                    parcelaPorcentagem: Number(subItem?.parcelaPorcentagem), 
                                    vrlParcela: vrlParcela * 100,
                                });
                                
                                return responseInsert.data.data.id
                            })
                        )
                        
                        if(insertSubParcelas.length > 0){
                            item.parcelasItens = insertSubParcelas
                        } else {
                            item.parcelasItens = []
                        }
                    }

                    delete item.subItems

                    return item
                })
            )

            const response = await Vue.prototype.$http.put('/Entity/updateMany/Parcelas', this.itemsParcelas);

            if(response.data.success){
                this.$notfy.success("Parcelas Atualizadas.");
                this.$emit('save')
            } else {
                this.$notfy.error("Erro ao cadastrar as parcelas.");
            }
        },

        getDateFormat(date){
            if(date === null || date === undefined || date == '') return 'Não Informado'
            return moment(date).format('DD/MM/YYYY')
        },

        calcPorcentagemParcela(value, valueFather, subItemCode){
            if(value && valueFather){
                
                const rawValue = Number(
                    String(value)
                    .replace(/[^0-9,-]+/g, '')
                    .replace('.', '')
                    .replace(',', '.')
                )

                this.totalParcelas = 0
                
                this.itemsParcelas.map(async (item) => {

                    if(item.subItems?.length > 0){
                        item.subItems = item.subItems.map((subItem) => {

                            if(subItem.code === subItemCode.code){
                                let porcentagem = (rawValue * 100) / valueFather
                                subItem.parcelaPorcentagem = porcentagem.toFixed(2)

                                if(subItem.parcelaPorcentage > 100){
                                    this.$notfy.error('Valor maior que 100% da parcela.')
                                    subItem.parcelaPorcentagem = 0
                                    subItem.vrlParcela = 0
                                }
                            }

                            this.totalParcelas += Number(subItem.vrlParcela)
                            if(this.totalParcelas > item.vrlParcela){

                                if(subItem.code === subItemCode.code){
                                    subItem.parcelaPorcentagem = 0
                                    subItem.vrlParcela = 0
                                }

                                this.$notfy.error('A soma não pode ser superior .')
                                this.componentKey += 1
                            }

                            return subItem
                        })
                    }
                    return item
                })

                this.componentKey += 1
            }
        },

        
        calcValue(value, valueFather, subItem){
            if(value > 100){
                subItem.parcelaPorcentagem = 0
                subItem.vrlParcela = 0
                this.$notfy.error('A soma não pode ser superior .')
                this.componentKey += 1

                return
            }

            let valor = String(value)
            .replace(',', '.')        // troca vírgula por ponto
            .replace(/[^0-9.]/g, '')  // remove tudo que não for número/ponto

            let num = parseFloat(valor)

            if (isNaN(num)) num = 0
            if (num > 100) num = 100


            subItem.vrlParcela = ((Number(num) / 100 ) * valueFather).toFixed(2);
            subItem.parcelaPorcentagem = num.toFixed(2).replace('.', ',')
            this.componentKey += 1
        },

    },
    watch: {
        open(value){
            this.dialog = value

            if(value) this.getParcelasByJob()
        },

        itemsParcelas: {
            handler(items) {
                console.log('watch itemsParcelas >>> ', items)
            }
        }
    }
}

</script>

<style scoped>
    .custom-dialog {
        top: 50% !important;
        transform: translateY(-50%) !important;
    }
</style>